var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoLocationActivity = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 44,
  fill: "none",
  viewBox: "0 0 36 44"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_8491_33871)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4D85DB",
  d: "M32 17c0 7.732-14 22-14 22S4 24.732 4 17 10.268 3 18 3s14 6.268 14 14"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m19.992 23.604-.375 1.266a.73.73 0 0 1-.531.49q-.567.14-1.085.14-.524 0-1.143-.142a.73.73 0 0 1-.552-.522L16 23.604zM17.91 10.5H18c1.252 0 2.267 1.965 2.267 5.657 0 1.18-.248 2.395-.526 3.5l-.168.65-.244.91q-.186.703-.434 1.42l-.096.266h-1.597l-.095-.264a20 20 0 0 1-.3-.936l-.129-.463-.33-1.235c-.313-1.196-.614-2.543-.614-3.848 0-3.692 1.015-5.657 2.267-5.657-2.072 0-3.75 2.432-3.75 5.431 0 1.732.316 3.119 1.289 4.69l.159.25q.627.956 1.09 2.031l-1.084.001a7.4 7.4 0 0 0-1.07-1.413l-.2-.207C12.705 19.54 12 18.031 12 16.135c0-3.003 2.619-5.448 5.726-5.627zm.388.015-.124-.011-.084-.004c3.187.091 5.91 2.574 5.91 5.635 0 1.823-.652 3.289-2.24 4.948l-.195.2q-.825.831-1.27 1.62h-1.084l.08-.183q.349-.78.786-1.497l.383-.604c.973-1.571 1.29-2.958 1.29-4.69 0-2.854-1.52-5.194-3.452-5.414",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_8491_33871",
  width: 36,
  height: 44,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_8491_33871"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_8491_33871",
  result: "shape"
})))));
export default SvgIcoLocationActivity;